









import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ExpressionFunctionKinds, ExpressionKinds, ExpressionOperatorKinds, ExpressionReferenceKinds, ICalculationExpressionBehavior, ICalculationExpressionContent, ICalculationExpressionObjectReference, TextObjectKinds } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { CalculateObjectEditor, TextObjectEditor } from "../../../../../formatEditor/domain/editableFormat/objectEditors";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";

@Component
export default class CalculationExpressionBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (write: (source: ICalculationExpressionBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICalculationExpressionBehavior) => T, defaultValue: T) => T;
  
  @Prop()
  currentObjectId: number;
  
  @Prop()
  commonComponents: CommonComponentsContainer;

  get items(): ICalculationExpressionContent[] {
    return this.readPropertyOrDefault(s => s.contents, []);
  }

  set items(value: ICalculationExpressionContent[]) {
    this.writePropertyWhenValid(s => s.contents = value);
  }

  get settableItems(): ICalculationExpressionContent[] {
    // 自身のオブジェクト、期間比較のオブジェクト、textのHIS項目オブジェクト(計算対象は含む)は省く
    return Enumerable.from(this.commonComponents.allPagesFormatObjects)
      .where(o => Enumerable.from(this.settableObjectTypeName).contains(o.objectTypeName().getValue())
        && o.id().getValue() !== this.currentObjectId
        && !(o.objectTypeName().getValue() === "calculate" && (o as CalculateObjectEditor).kind().getValue() === ExpressionKinds.DateComparison)
        && !(o.objectTypeName().getValue() === "text" && (o as TextObjectEditor).objectKind().getValue() === TextObjectKinds.HisItem && !o.getSelectedHisInformation().calculate))
      .select(o => this.toICalculationExpressionContent(o))
      .where(s => !!(s.reference as ICalculationExpressionObjectReference).key).toArray();
  }

  async showCalculationExpressionEditDialog() {
    const dialog = this.commonComponents.getDialogs().getCalculationExpressionEditDialog();
    this.fillCalculationExpressionName(this.settableItems, this.items);
    const settingItems = await dialog.show(this.settableItems, this.items);
    if (!settingItems) { return; }
    this.items = settingItems;
  }

  private toICalculationExpressionContent(object: IFormatObjectEditable): ICalculationExpressionContent {
    const linkedObject = object.toLinkedObjectIdentifier();
    const isCalculate = (object.objectTypeName().getValue() === "calculate");
    return {
      kind: ExpressionReferenceKinds.Object,
      reference: {
        type: linkedObject.type,
        id: linkedObject.id,
        key: linkedObject.key,
        subKey: linkedObject.subKey,
        expressionKind: isCalculate ? (object as CalculateObjectEditor).kind().getValue() : undefined,
        alternativeValue: undefined,
      },
      operator: ExpressionOperatorKinds.Add,
      brackets: {
        openCount: 0,
        closeCount: 0,
      },
      name: !!object.hisInformationKey().getValue() ? object.getHisInformationName() : object.name().getValue(),
    };
  }

  // 表示名を補完
  private fillCalculationExpressionName(settableItems: ICalculationExpressionContent[], items: ICalculationExpressionContent[]) {
    Enumerable.from(items).forEach(i => {
      if (i.kind === ExpressionReferenceKinds.Object) {
        const target = Enumerable.from(settableItems)
          .firstOrDefault(s => (i.reference as ICalculationExpressionObjectReference).key === (s.reference as ICalculationExpressionObjectReference).key);
        if (!!target) {
          i.name = target.name;
        } 
      } else if (i.kind === ExpressionReferenceKinds.Fixed) {
        i.name = (i.reference as number).toString();
      } else if (i.kind === ExpressionReferenceKinds.Function) {
        i.name = ((i.reference as ExpressionFunctionKinds) === ExpressionFunctionKinds.Root)
            ? "√" : "LN";
      }
    });
  }

  get settableObjectTypeName(): string[] {
    return [    
    "tag",
    "text",
    "script",
    "scriptlink",
    "check",
    "circleselect",
    "combo",
    "roll",
    "calculate"
    ];
  }
}
